import { isNaN, isNil } from 'lodash-es';
import store from 'store2';

// Change number to string adding spaces, commas and dots in right places
export const formatNumber = (x: number): string | number => {
    let result;
    if (isNil(x) || isNaN(x)) {
        return 0;
    }
    const userLocale = store.has('locale') ? store('locale') : 'en';
    try {
        result = x.toLocaleString(userLocale);
    } catch (e) {
        result = `${x}`;
    }
    return result;
};
